import React from 'react';
import BaseClass from '@/pages/BaseClass';

import {
	Form,
	Button,
	Input,
	Cascader,
	Checkbox,
	Upload,
} from 'antd'
import $ from 'jquery';
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost
} from '@/utils/Tools';

export default class App extends BaseClass
{
	
	constructor(props)
	{
		super(props);
		
		this.state={
			'siteUrl':'',
			
			'validateTimer':0,
			'provinceList':[],
			'rules':{
				'user_name':[
					{
						required: true,
						message: '请输入手机号',
					},
					{
						pattern: /^1\d\d\d{8}$/,
						message: '请输入正确的手机号',
					},
				],
				'validate_code':[
					{
						required: true,
						message: '请输入验证码',
					},
				],
				'password':[
					{
						required: true,
						message: '请输入密码',
					},
				],
				'password1':[
					{
						required: true,
						message: '请确认密码',
					},
					{
						validator: (rule,value)=>{
							if(value != this.mainForm.getFieldValue('password'))
								return Promise.reject(new Error('两次密码输入不一致'));
							else 
								return Promise.resolve();
						},
					},
				],
				'company_name':[
					{
						required: true,
						message: '请输入公司名称',
					},
				],
				'area_info':[
					{
						required: true,
						message: '请选择地区',
					},
					{
						validator: (rule,value)=>{
							if(!Array.isArray(value) || !value.length)
								return Promise.reject(new Error('请选择所在地区'));
							
							if(value.length != 3)
							{
								let find = this.state.provinceList.find(row=>{
									return row.value == value[0];
								});
								if( value.length == 1)
								{
									
									if(find.children.length)
										return Promise.reject(new Error('请选择所在城市信息'));
								}
								else if(value.length == 2)
								{
									let find1 = find.children.find(row=>{
										return row.value == value[1];
									});
									if(find1.children.length)
										return Promise.reject(new Error('请选择所在地区信息'));
								}
							}
							return Promise.resolve();
						},
					},
				],
				'address':[
					{
						required: true,
						message: '请输入详细地址',
					},
				],
				'business_license':[
					{
						required: true,
						message: '请上传营业执照',
					},
				],
			},
		};
	}
	
	componentDidMount()
	{
		let siteUrl = CommonValue.get('site_url');
		this.setState({
			'siteUrl':siteUrl,
		});
		
		this.getAreaList(0)
			.then(data=>{
				data.forEach(row=>{
					row.children = [];
					row.isLeaf = false;
				});
				this.setState({
					'provinceList':data,
				});
			});
		
		document.title = '注册 - ' + CommonValue.get('site_name');
	}
	
	//发送验证码
	sendValidate()
	{
		this.mainForm.validateFields(['user_name'])
			.then((info)=>{
				let phone = info['user_name'];
				let url = pcUrl('index','sendValidate');
				let param = {
					'phone':phone,
					'is_register':1,
				};
				httpPost(url,param)
					.then(()=>{
						message('验证码已发送','success');
						this.setState({
							'validateTimer':10,
						});
						let loop = window.setInterval(()=>{
							let timer = this.state.validateTimer;
							if(--timer == 0)
								window.clearInterval(loop);
							
							this.setState({
								'validateTimer':timer,
							});
						},1000);
					});
			});
	}
	
	loadAreaData(data)
	{
		let lastData = data[data.length - 1];
		if(lastData.children && lastData.children.length) return;
		
		lastData.loading = true;
		this.getAreaList(lastData.value)
			.then(data1=>{
				if(data1.length)
				{
					data1.forEach(row=>{
						if(data.length == 1)
						{
							row.children = [];
							row.isLeaf = false;
						}
					});
					lastData.children = data1;
				}
				else
				{
					lastData.isLeaf = true;
				}
				lastData.loading = false;
				this.setState({
					'provinceList':[...this.state.provinceList],
				});
			});
	}
	
	uploadChange(data)
	{
		if(data.file && data.file.response)
		{
			let response = data.file.response;
			if(response.code != 0)
			{
				message(response.message);
				return;
			}
			this.mainForm.setFieldsValue({
				'business_license':response.data,
			});
		}
	}
	
	getAreaList(parentId)
	{
		if(!parentId) parentId = 0;
		
		let url =pcUrl('index','areaList');
		let param = {
			'parent_id':parentId,
		};
		
		return new Promise((resolve,reject)=>{
			httpPost(url,param)
				.then(data=>{
					//转换data
					data = data.map(row=>{
						return {
							'label':row['area_name'],
							'value':row['area_id'],
						};
					});
					
					resolve(data);
				});
		});
	}

	submit(info)
	{
		//获取地区信息
		info['province_id'] = info['area_info'][0];
		info['city_id'] = info['area_info'][1] || 0;
		info['area_id'] = info['area_info'][2] || 0;
		info['area_info'] = [];
		this.state.provinceList.some(row=>{
			if(row.value == info['province_id'])
			{
				info['area_info'].push(row.label);
				info['city_id'] && row.children.some(row1=>{
					if(row1.value == info['city_id'])
					{
						info['area_info'].push(row1.label);
						info['area_id'] && row1.children.some(row2=>{
							if(row2.value == info['area_id'])
							{
								info['area_info'].push(row2.label);
								return true;
							}
						});
						return true;
					}
				});
				return true;
			}
		});
		info['area_info'] = info['area_info'].join(' ');
		
		let url = pcUrl('index','register');
		let param = info;
		httpPost(url,param)
			.then(data=>{
				message('用户注册成功，请您等待系统审核，成功后便可登录','success');
				window.location.href = ngUrl('login');
			});
	}
	
	_login(data)
	{
		CommonValue.set('user_info',data);
		global.setRootState({
			'userInfo':data,
		});
		window.location.href = ngUrl('user');
	}
	
	render()
	{
		return (
			<div className="bg-gray">
				<div className="body">
					<div className="ur-here">
						<a href={this.state.siteUrl}>首页</a>
						&gt;
						<span>注册新用户</span>
					</div>
					<div className="login-form register-form">
						<div className="login-right">
							<h3>注册新用户</h3>
							<Form
								labelCol={{ span:4 }}
								wrapperCol={{ span:20 }}
								onFinish={(data)=>this.submit(data)}
								onFinishFailed={data=>this.focusError(data)}
								ref={e=>this.mainForm = e}>
								<Form.Item name="user_name" label="手机号码" rules={this.state.rules['user_name']}>
									<Input />
								</Form.Item>
								<Form.Item name="validate_code" label="验证码" rules={this.state.rules['validate_code']}>
									<Input.Group>
										<Input style={{'width':'70%'}} onChange={e=>this.mainForm.setFieldsValue({'validate_code':e.target.value})} />
										&nbsp;&nbsp;
										<Button disabled={this.state.validateTimer !== 0} style={{'width':'28%'}} onClick={()=>this.sendValidate()}>
											{this.state.validateTimer ? '剩余'+this.state.validateTimer+'秒' : '获取验证码'}
										</Button>
									</Input.Group>
								</Form.Item>
								<Form.Item label="密码" name="password" rules={this.state.rules['password']}>
									<Input.Password />
								</Form.Item>
								<Form.Item label="确认新密码" name="password1" rules={this.state.rules['password1']}>
									<Input.Password />
								</Form.Item>
								<Form.Item label="公司名称" name="company_name" rules={this.state.rules['company_name']}>
									<Input />
								</Form.Item>
								<Form.Item label="所在地区" name="area_info" rules={this.state.rules['area_info']}>
									<Cascader options={this.state.provinceList} loadData={e=>this.loadAreaData(e)} changeOnSelect placeholder="请选择地区" />
								</Form.Item>
								<Form.Item label="详细地址" name="address" rules={this.state.rules['address']}>
									<Input />
								</Form.Item>
								<Form.Item label="营业执照" name="business_license" rules={this.state.rules['business_license']}>
									<Upload
										action={pcUrl('index','upload')}
										showUploadList={false}
										data={{'thumb_size':'500,500'}}
										onChange={e=>this.uploadChange(e)}
										listType="picture-card">
										<Form.Item noStyle shouldUpdate={(old,cur)=>cur['business_license'] != old['business_license']}>
											{()=>this.mainForm && this.mainForm.getFieldValue('business_license') ? (
												<img src={this.mainForm.getFieldValue('business_license') } alt="avatar" style={{ width: '100%' }} />
											):(
												<div>
													<span style={{fontSize:'20px'}}>+</span>
													<br/>
													上传图片
												</div>
											)}
										</Form.Item>
									</Upload>
								</Form.Item>
								<Form.Item wrapperCol={{ offset:4, span:20 }}>
									<Button style={{'width':'100%'}} type="primary" htmlType="submit">确认</Button>
									<div style={{'marginTop':'.5em'}}>
										已有账号，
										<a href={ngUrl('login')}>继续登录</a>
									</div>
								</Form.Item>
							</Form>
						</div>
						<div className="clear"></div>
					</div>
					<div className="height-20"></div>
				</div>
			</div>
		);
	}
}

